import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./iGateReport.css";
import DateRangePicker from "../component/Picker";
import excelIcon from "../assets/icons/excel.png";
import pdfIcon from "../assets/icons/pdf.png";
import axios from "axios";
import authStore from "../store/AuthStore";
function IGateReport() {
  const [date, setDate] = useState("");

  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      .toISOString()
      .split("T")[0],
  );

  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const baseUrl =
    authStore.authData?.url ||
    JSON.parse(sessionStorage.getItem("authData"))?.url;
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [searchTerm, setSearchTerm] = useState("");
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [viewType, setViewType] = useState("Employee Exit");

  const handleDateChange = (start, end) => {
    setStartDate(start || "");
    setEndDate(end || "");
  };
  const [dashboardData, setDashboardData] = useState({
    total_entries: 0,
    employees: 0,
    visitors: 0,
    vehicles: 0,
    checked_in: 0,
    checked_out: 0,
    currently_inside: 0,
  });
  useEffect(() => {
    const now = new Date();

    const formattedDate = now.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    setDate(formattedDate);
  }, []);

  useEffect(() => {
    const fetchGateLogs = async () => {
      try {
        setLoading(true);

        const formData = new URLSearchParams();

        if (startDate && endDate) {
          formData.append("from_date", startDate);
          formData.append("to_date", endDate);
        }

        formData.append("type", viewType);
        if (statusFilter !== "All Status") {
          formData.append("status", statusFilter);
        }

        console.log("MAIN API PAYLOAD =>", formData.toString());
        let headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          ...(await authStore.getAuthHeader()),
        };

        let response;

        try {
          response = await axios.post(
            `${baseUrl}/api/igate_log_report`,
            formData,
            { headers },
          );
        } catch (error) {
          const message = (error.response?.data?.message || "").toLowerCase();

          if (message.includes("invalid token")) {
            headers = {
              "Content-Type": "application/x-www-form-urlencoded",
              ...(await authStore.refreshToken()),
            };

            response = await axios.post(
              `${baseUrl}/api/igate_log_report`,
              formData,
              { headers },
            );
          } else {
            throw error;
          }
        }
        if (response?.data?.data) {
          const formattedData = response.data.data.map((item, index) => ({
            id: index + 1,

            type: item.type || "-",

            name: item.name || "-",

            empId: item.emp_id_proof || "-",

            department: item.department_company || "-",

            purpose: item.purpose || "-",

            meetPerson: item.person_to_meet || "-",

            inDate: item.in_time ? item.in_time.split(" ")[0] : "-",

            inTime: item.in_time ? item.in_time.split(" ")[1] : "-",

            outDate: item.out_time ? item.out_time.split(" ")[0] : "-",

            outTime: item.out_time ? item.out_time.split(" ")[1] : "",

            duration: item.duration || "-",

            vehicle: item.vehicle_no || "-",

            badge: item.badge_no || "-",

            status: item.status || "-",
            remarks: item.remarks || "-",
          }));

          setRecords(formattedData);
        } else {
          setRecords([]);
        }
      } catch (error) {
        console.error("API ERROR :", error);
        setRecords([]);
      } finally {
        setLoading(false);
      }
    };
    const fetchDashboardData = async () => {
      try {
        const formData = new URLSearchParams();

        formData.append("type", viewType);

        if (statusFilter !== "All Status") {
          formData.append("status", statusFilter);
        }

        if (startDate && endDate) {
          formData.append("from_date", startDate);
          formData.append("to_date", endDate);
        }

        let headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          ...(await authStore.getAuthHeader()),
        };

        let response;

        try {
          response = await axios.post(
            `${baseUrl}/api/igate_dashboard`,
            formData,
            { headers },
          );
        } catch (error) {
          const message = (error.response?.data?.message || "").toLowerCase();

          if (message.includes("invalid token")) {
            headers = {
              "Content-Type": "application/x-www-form-urlencoded",
              ...(await authStore.refreshToken()),
            };

            response = await axios.post(
              `${baseUrl}/api/igate_dashboard`,
              formData,
              { headers },
            );
          } else {
            throw error;
          }
        }

        if (response?.data?.data) {
          setDashboardData(response.data.data);
        }
      } catch (error) {
        console.log("DASHBOARD API ERROR :", error);
      }
    };
    fetchGateLogs();

    fetchDashboardData();
  }, [startDate, endDate, viewType, statusFilter, baseUrl]);

  const fetchExportData = async () => {
    try {
      const formData = new URLSearchParams();

      formData.append("type", viewType);

      if (statusFilter !== "All Status") {
        formData.append("status", statusFilter);
      }

      if (startDate && endDate) {
        formData.append("from_date", startDate);
        formData.append("to_date", endDate);
      }

      console.log(formData.toString());

      let headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        ...(await authStore.getAuthHeader()),
      };

      let response;

      try {
        response = await axios.post(
          `${baseUrl}/api/igate_log_report`,
          formData,
          { headers },
        );
      } catch (error) {
        const message = (error.response?.data?.message || "").toLowerCase();

        // TOKEN EXPIRED
        if (message.includes("invalid token")) {
          headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            ...(await authStore.refreshToken()),
          };

          response = await axios.post(
            `${baseUrl}/api/igate_log_report`,
            formData,
            { headers },
          );
        } else {
          throw error;
        }
      }

      return response?.data?.data || [];
    } catch (error) {
      console.error("EXPORT ERROR :", error);

      return [];
    }
  };

  const exportExcel = async () => {
    const data = await fetchExportData();

    if (!data.length) return;

    const formattedData = data.map((item, index) => ({
      "#": index + 1,
      TYPE: item.type || "-",
      "GATE PASS ID": item.badge_no || "-",
      NAME: item.name || "-",
      "EMP/ID": item.emp_id_proof || "-",
      DEPARTMENT: item.department_company || "-",
      PURPOSE: item.purpose || "-",
      STATUS: item.status || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "IGate Report");

    XLSX.writeFile(workbook, `igate_report_${Date.now()}.xlsx`);
  };

  const exportPDF = async () => {
    const data = await fetchExportData();

    if (!data.length) return;

    const doc = new jsPDF("landscape");

    const tableColumn = [
      "#",
      "TYPE",
      "NAME",
      "EMP ID",
      "DEPARTMENT",
      "PURPOSE",
      "IN DATE",
      "OUT DATE",
      "STATUS",
    ];

    const tableRows = data.map((item, index) => [
      index + 1,
      item.type || "-",
      item.name || "-",
      item.emp_id_proof || "-",
      item.department_company || "-",
      item.purpose || "-",
      item.in_time ? item.in_time.split(" ")[0] : "-",
      item.out_time ? item.out_time.split(" ")[0] : "-",
      item.status || "-",
    ]);

    doc.text("IGate Report", 14, 15);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });

    window.open(doc.output("bloburl"), "_blank");
  };
  const filteredRecords = records
    .filter((record) => {
      if (statusFilter !== "All Status" && record.status !== statusFilter) {
        return false;
      }
      return true;
    })
    .filter((record) => {
      if (!searchTerm) return true;

      const term = searchTerm.toLowerCase();

      return (
        record.name.toLowerCase().includes(term) ||
        record.type.toLowerCase().includes(term) ||
        record.empId.toLowerCase().includes(term) ||
        record.department.toLowerCase().includes(term) ||
        record.purpose.toLowerCase().includes(term) ||
        record.vehicle.toLowerCase().includes(term) ||
        record.badge.toLowerCase().includes(term)
      );
    });

  return (
    <div className="igate-container">
      {/* HEADER */}
      <div className="dashboard-header">
        <div>
          <h1 className="dashboard-title">Gate Activity</h1>
          <p className="dashboard-subtitle">
            Gate movement for:
            {startDate && endDate ? `${startDate} To ${endDate}` : date}
          </p>
        </div>

        <div className="dashboard-picker">
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onDateChange={handleDateChange}
          />
        </div>
      </div>

      {/* DUMMY CARDS */}
      <div className="stats-grid">
        <div className="dashboard-card blue">
          <div className="card-top">
            <h4>TOTAL ENTRIES</h4>
            <h2>{dashboardData.total_entries}</h2>
          </div>

          <p>All movements</p>
        </div>
        {viewType === "Employee Exit" ? (
          <div className="dashboard-card indigo">
            <div className="card-top">
              <h4>EMPLOYEES</h4>
              <h2>{dashboardData.employees}</h2>
            </div>

            <p>Staff entries</p>
          </div>
        ) : (
          <div className="dashboard-card cyan">
            <div className="card-top">
              <h4>VISITORS</h4>
              <h2>{dashboardData.visitors}</h2>
            </div>

            <p>External persons</p>
          </div>
        )}
        <div className="dashboard-card purple">
          <div className="card-top">
            <h4>VEHICLES</h4>
            <h2>{dashboardData.vehicles}</h2>
          </div>

          <p>Vehicle entries</p>
        </div>
        <div className="dashboard-card green">
          <div className="card-top">
            <h4>CHECKED IN</h4>
            <h2>{dashboardData.checked_in}</h2>
          </div>
          <p>Entered premises</p>
        </div>
        <div className="dashboard-card red">
          <div className="card-top">
            <h4>CHECKED OUT</h4>
            <h2>{dashboardData.checked_out}</h2>
          </div>
          <p>Exited premises</p>
        </div>
        <div className="dashboard-card yellow">
          <div className="card-top">
            <h4>CURRENTLY INSIDE</h4>
            <h2>{dashboardData.currently_inside}</h2>
          </div>
          <p>Still on premises</p>
        </div>
      </div>

      {/* TABLE */}
      <div className="table-card">
        <div className="table-header">
          <div className="table-title-row">
            {/* <h2>📋 Period — {date}</h2> */}

            <input
              type="text"
              className="table-search"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="table-actions">
            <div className="table-left-actions">
              <button className="action-btn export-btn" onClick={exportExcel}>
                <img
                  src={excelIcon}
                  alt="Export"
                  style={{ width: "14px", height: "14px" }}
                />
              </button>

              <button className="action-btn print-btn" onClick={exportPDF}>
                <img
                  src={pdfIcon}
                  alt="Print"
                  style={{ width: "14px", height: "14px" }}
                />
              </button>
            </div>

            {/* RIGHT */}
            <div className="table-right-actions">
              <div className="toggle-container">
                <span
                  className={`toggle-label ${
                    viewType === "Visitor" ? "active-label" : ""
                  }`}
                >
                  Visitor
                </span>

                <label className="switch">
                  <input
                    type="checkbox"
                    checked={viewType === "Employee Exit"}
                    onChange={(e) =>
                      setViewType(
                        e.target.checked ? "Employee Exit" : "Visitor",
                      )
                    }
                  />

                  <span className="slider"></span>
                </label>

                <span
                  className={`toggle-label ${
                    viewType === "Employee Exit" ? "active-label" : ""
                  }`}
                >
                  Employee
                </span>
              </div>

              {/* STATUS FILTER */}
              <select
                className="table-filter"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option>All Status</option>
                <option>Scheduled</option>
                <option>Inside</option>
                <option>Exited</option>
                <option>Withdrawn</option>
              </select>
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="table-wrapper">
          <table className="igate-table">
            <thead>
              <tr>
                <th>#</th>
                <th>TYPE</th>
                <th>GATE PASS ID</th>
                <th>NAME</th>

                <th>{viewType === "Employee Exit" ? "EMP ID" : "ID PROOF"}</th>

                <th>DEPT / COMPANY</th>
                <th>PURPOSE</th>

                {viewType === "Visitor" && <th>PERSON TO MEET</th>}

                {viewType === "Visitor" ? (
                  <>
                    <th>IN DATE</th>
                    <th>OUT DATE</th>
                    <th>IN TIME</th>
                    <th>OUT TIME</th>
                  </>
                ) : (
                  <>
                    <th>DATE</th>
                    <th>IN TIME</th>
                    <th>OUT TIME</th>
                  </>
                )}

                <th>DURATION</th>
                <th>VEHICLE NO.</th>
                <th>STATUS</th>
                <th>REMARKS</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={viewType === "Visitor" ? 16 : 15}
                    className="no-data"
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredRecords.length > 0 ? (
                filteredRecords.map((record, index) => (
                  <tr key={record.id}>
                    <td>{index + 1}</td>
                    <td>
                      <span
                        className={`badge ${
                          record.type?.toLowerCase().includes("employee")
                            ? "employee"
                            : record.type?.toLowerCase().includes("vehicle")
                              ? "vehicle"
                              : "visitor"
                        }`}
                      >
                        {record.type}
                      </span>
                    </td>
                    <td>{record.badge}</td>
                    <td>{record.name}</td>
                    <td className="emp-proof">{record.empId}</td>
                    <td>{record.department}</td>
                    <td>
                      <span className="badge purpose-badge">
                        {record.purpose}
                      </span>
                    </td>
                    {viewType === "Visitor" ? (
                      <td>{record.meetPerson}</td>
                    ) : null}
                    {viewType === "Visitor" ? (
                      <>
                        <td>{record.inDate}</td>
                        <td>{record.outDate}</td>

                        <td>
                          <span className="in-time">
                            {record.inTime || "-"}
                          </span>
                        </td>

                        <td>
                          <span className="out-time">
                            {record.outTime || "-"}
                          </span>
                        </td>
                      </>
                    ) : (
                      <>
                        <td>{record.outDate}</td>

                        <td>
                          <span className="in-time">
                            {record.inTime || "-"}
                          </span>
                        </td>

                        <td>
                          <span className="out-time">
                            {record.outTime || "-"}
                          </span>
                        </td>
                      </>
                    )}
                    <td>{record.duration}</td>
                    <td>{record.vehicle}</td>
                    <td>
                      <span
                        className={`status ${
                          record.status === "Inside"
                            ? "inside"
                            : record.status === "Scheduled"
                              ? "scheduled"
                              : record.status === "Withdrawn"
                                ? "withdrawn"
                                : record.status === "Exited"
                                  ? "exited"
                                  : ""
                        }`}
                      >
                        {record.status}
                      </span>
                    </td>
                    <td>{record.remarks}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={viewType === "Visitor" ? 16 : 15}
                    className="no-data"
                  >
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default IGateReport;
